var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "500px" },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          $event.preventDefault()
          return _vm.onenter.apply(null, arguments)
        },
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            [
              _c("span", { staticClass: "headline" }, [
                _vm._v("Cluster Config"),
              ]),
              _c("v-spacer"),
              _c("r-authorize", {
                attrs: {
                  master: _vm.masterAccess,
                  locked: _vm.model.locked,
                  enabled: _vm.model.enabled,
                },
                on: {
                  "update:locked": function ($event) {
                    return _vm.$set(_vm.model, "locked", $event)
                  },
                  "update:enabled": function ($event) {
                    return _vm.$set(_vm.model, "enabled", $event)
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "12", sm: "12" } },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "mr-2",
                          attrs: { small: "" },
                          on: {
                            click: function ($event) {
                              return _vm.showPreview()
                            },
                          },
                        },
                        [_vm._v("View JSON")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6", sm: "6" } },
                    [
                      _c("v-text-field", {
                        directives: [
                          { name: "ascii-only", rawName: "v-ascii-only" },
                        ],
                        attrs: { label: "Name:" },
                        model: {
                          value: _vm.model.name,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.model,
                              "name",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "model.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6", sm: "6" } },
                    [
                      _c("v-text-field", {
                        directives: [
                          { name: "ascii-only", rawName: "v-ascii-only" },
                        ],
                        attrs: { label: "Key:" },
                        model: {
                          value: _vm.model.key,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.model,
                              "key",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "model.key",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c("r-item-table", {
                    attrs: { items: _vm.model.items, title: "Items" },
                    on: {
                      "update:items": function ($event) {
                        return _vm.$set(_vm.model, "items", $event)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.cancel },
                },
                [_vm._v(" Cancel ")]
              ),
              !_vm.lockedAssess || _vm.masterAccess
                ? _c(
                    "v-btn",
                    {
                      attrs: { color: "blue darken-1", text: "" },
                      on: { click: _vm.save },
                    },
                    [_vm._v(" Save ")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c("r-preview-dialog", { ref: "preview-dialog" }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }